export default __webpack_public_path__ + "static/media/43.39321844.jpeg";